// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* qchat_fe/src/Component/SideData/Overview/AiAgentWorkFlow/ParallelActionsPanel.module.css */

.ParallelActionsPanel_panel__xKhJb {
  margin-top: 16px;
  padding: 14px 16px;
  background: #fafbff;
  border: 1px solid #dbe4ff;
  border-left: 3px solid #5b7cfa;
  border-radius: 8px;
}

.ParallelActionsPanel_panelHeader__LhxFx {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 6px;
}

.ParallelActionsPanel_panelHeaderLeft__gIJuA {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ParallelActionsPanel_panelIcon__rtfZH {
  color: #5b7cfa;
}

.ParallelActionsPanel_panelTitle__I2tJX {
  font-size: 13px;
  font-weight: 600;
  color: #2d3748;
  letter-spacing: 0.2px;
}

.ParallelActionsPanel_panelSubtitle__O0n3a {
  font-size: 11px;
  color: #718096;
  font-weight: 500;
  padding: 1px 8px;
  background: #edf2f7;
  border-radius: 10px;
  margin-left: 2px;
}

.ParallelActionsPanel_panelHelp__ISVah {
  margin: 0 0 10px 0;
  font-size: 12px;
  color: #4a5568;
  line-height: 1.5;
}

.ParallelActionsPanel_addButton__9QLF\\+ {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  font-size: 12px;
  font-weight: 600;
  color: #ffffff;
  background: #5b7cfa;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.15s ease;
}

.ParallelActionsPanel_addButton__9QLF\\+:hover {
  background: #4a6ce0;
}

.ParallelActionsPanel_emptyState__Ct1NX {
  padding: 12px 14px;
  font-size: 12px;
  color: #718096;
  background: #ffffff;
  border: 1px dashed #cbd5e0;
  border-radius: 6px;
  text-align: center;
}

.ParallelActionsPanel_triggerList__Esa\\+t {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ParallelActionsPanel_triggerRow__zgVmX {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
}

.ParallelActionsPanel_providerBadge__-NKNJ {
  flex-shrink: 0;
  width: 26px;
  height: 26px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  background: #f7fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
}

.ParallelActionsPanel_triggerBody__Z9IUt {
  flex: 1 1;
  min-width: 0;
}

.ParallelActionsPanel_triggerName__jRTOc {
  font-size: 12px;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 2px;
}

.ParallelActionsPanel_triggerMeta__4TAtl {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.ParallelActionsPanel_triggerOpName__H0TD\\+ {
  font-size: 10.5px;
  color: #5b7cfa;
  background: #ebf0ff;
  padding: 1px 6px;
  border-radius: 4px;
  font-family: monospace;
}

.ParallelActionsPanel_triggerDesc__7ETYK {
  font-size: 11px;
  color: #a0aec0;
}

.ParallelActionsPanel_triggerActions__ItWMP {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.ParallelActionsPanel_iconBtn__\\+rcVa {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  background: transparent;
  border: 1px solid #e2e8f0;
  border-radius: 5px;
  cursor: pointer;
  color: #4a5568;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.ParallelActionsPanel_iconBtn__\\+rcVa:hover {
  background: #edf2f7;
  border-color: #cbd5e0;
}

.ParallelActionsPanel_iconBtnDanger__09wFl {
  color: #c53030;
}

.ParallelActionsPanel_iconBtnDanger__09wFl:hover {
  background: #fff5f5;
  border-color: #feb2b2;
}`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/AiAgentWorkFlow/ParallelActionsPanel.module.css"],"names":[],"mappings":"AAAA,6FAA6F;;AAE7F;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,0DAA0D;AAC5D;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB","sourcesContent":["/* qchat_fe/src/Component/SideData/Overview/AiAgentWorkFlow/ParallelActionsPanel.module.css */\n\n.panel {\n  margin-top: 16px;\n  padding: 14px 16px;\n  background: #fafbff;\n  border: 1px solid #dbe4ff;\n  border-left: 3px solid #5b7cfa;\n  border-radius: 8px;\n}\n\n.panelHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 6px;\n}\n\n.panelHeaderLeft {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.panelIcon {\n  color: #5b7cfa;\n}\n\n.panelTitle {\n  font-size: 13px;\n  font-weight: 600;\n  color: #2d3748;\n  letter-spacing: 0.2px;\n}\n\n.panelSubtitle {\n  font-size: 11px;\n  color: #718096;\n  font-weight: 500;\n  padding: 1px 8px;\n  background: #edf2f7;\n  border-radius: 10px;\n  margin-left: 2px;\n}\n\n.panelHelp {\n  margin: 0 0 10px 0;\n  font-size: 12px;\n  color: #4a5568;\n  line-height: 1.5;\n}\n\n.addButton {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #ffffff;\n  background: #5b7cfa;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.addButton:hover {\n  background: #4a6ce0;\n}\n\n.emptyState {\n  padding: 12px 14px;\n  font-size: 12px;\n  color: #718096;\n  background: #ffffff;\n  border: 1px dashed #cbd5e0;\n  border-radius: 6px;\n  text-align: center;\n}\n\n.triggerList {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.triggerRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 12px;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n}\n\n.providerBadge {\n  flex-shrink: 0;\n  width: 26px;\n  height: 26px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  background: #f7fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n}\n\n.triggerBody {\n  flex: 1;\n  min-width: 0;\n}\n\n.triggerName {\n  font-size: 12px;\n  font-weight: 600;\n  color: #2d3748;\n  margin-bottom: 2px;\n}\n\n.triggerMeta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.triggerOpName {\n  font-size: 10.5px;\n  color: #5b7cfa;\n  background: #ebf0ff;\n  padding: 1px 6px;\n  border-radius: 4px;\n  font-family: monospace;\n}\n\n.triggerDesc {\n  font-size: 11px;\n  color: #a0aec0;\n}\n\n.triggerActions {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.iconBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  background: transparent;\n  border: 1px solid #e2e8f0;\n  border-radius: 5px;\n  cursor: pointer;\n  color: #4a5568;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.iconBtn:hover {\n  background: #edf2f7;\n  border-color: #cbd5e0;\n}\n\n.iconBtnDanger {\n  color: #c53030;\n}\n\n.iconBtnDanger:hover {\n  background: #fff5f5;\n  border-color: #feb2b2;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `ParallelActionsPanel_panel__xKhJb`,
	"panelHeader": `ParallelActionsPanel_panelHeader__LhxFx`,
	"panelHeaderLeft": `ParallelActionsPanel_panelHeaderLeft__gIJuA`,
	"panelIcon": `ParallelActionsPanel_panelIcon__rtfZH`,
	"panelTitle": `ParallelActionsPanel_panelTitle__I2tJX`,
	"panelSubtitle": `ParallelActionsPanel_panelSubtitle__O0n3a`,
	"panelHelp": `ParallelActionsPanel_panelHelp__ISVah`,
	"addButton": `ParallelActionsPanel_addButton__9QLF+`,
	"emptyState": `ParallelActionsPanel_emptyState__Ct1NX`,
	"triggerList": `ParallelActionsPanel_triggerList__Esa+t`,
	"triggerRow": `ParallelActionsPanel_triggerRow__zgVmX`,
	"providerBadge": `ParallelActionsPanel_providerBadge__-NKNJ`,
	"triggerBody": `ParallelActionsPanel_triggerBody__Z9IUt`,
	"triggerName": `ParallelActionsPanel_triggerName__jRTOc`,
	"triggerMeta": `ParallelActionsPanel_triggerMeta__4TAtl`,
	"triggerOpName": `ParallelActionsPanel_triggerOpName__H0TD+`,
	"triggerDesc": `ParallelActionsPanel_triggerDesc__7ETYK`,
	"triggerActions": `ParallelActionsPanel_triggerActions__ItWMP`,
	"iconBtn": `ParallelActionsPanel_iconBtn__+rcVa`,
	"iconBtnDanger": `ParallelActionsPanel_iconBtnDanger__09wFl`
};
export default ___CSS_LOADER_EXPORT___;
